import { useContentGenerationWatcher } from 'hooks/calendar/useContentGenerationWatcher'

//mounts the watcher hook that polls for active generations
export const ContentGenerationWatcher = () => {
  useContentGenerationWatcher()
  return null
}
